import { collection, getDocs } from "firebase/firestore";
import app from '../firebase';
import { getFirestore } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import "../RegistrationForm.css"
const Dashboard = () => {
  const [imageFile, setImageFile] = useState(null);
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  const [modalIsOpen, setIsOpen] = React.useState(false);
  
  function openModal(prn) {
    setIsOpen(true);
    handleDownload("stock/"+prn+"TH")
  }
  function closeModal() {
    setIsOpen(false);
  }

  const [bigData, setBigData] = useState([]);
const [allowed, setAllowed] = useState(false);

const sortByAge = () => {
  const sortedPeople = [...bigData]; // Create a shallow copy of the original array
  sortedPeople.sort((a, b) => a.timestamp.seconds - b.timestamp.seconds);
  setBigData(sortedPeople); // Update the state with the sorted array
};

useEffect(() => {
  const db = getFirestore(app);
  const fetchData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "treasureHunt"));
      const newData = [];
      querySnapshot.forEach((doc) => {
        const f = doc.data();
        newData.push(f);
      });
      setBigData(newData);
      setAllowed(true);
    } catch (e) {
      console.error(e);
    }
  };

  fetchData();
}, []);

// Call sortByAge after the data has been set
useEffect(() => {
  if (allowed) {
    sortByAge();
  }
}, [allowed]);

    console.log("big data",bigData);

    const handleDownload=(address)=>{
        const storage = getStorage();
        getDownloadURL(ref(storage, address))
        .then((url) => {
            const img = document.getElementById('myimg');
            img.setAttribute('src', url);
        })
    }
    function convertToCSV(jsonData) {
      const headers = Object.keys(jsonData[0]);
    
      const csvRows = [];
      csvRows.push(headers.join(',')); // Header row
    
      for (const row of jsonData) {
        const values = headers.map(header => row[header]);
        csvRows.push(values.join(','));
      }
    
      return csvRows.join('\n');
    }
    
    function downloadCSV(){
      const csv = convertToCSV(bigData);
      
      // Create a Blob (Binary Large Object) from the CSV data
      const blob = new Blob([csv], { type: 'text/csv' });
      
      // Create a URL for the Blob
      const url = window.URL.createObjectURL(blob);
      
      // Create a link element for downloading the CSV
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.csv'; // Specify the filename for the download
      
      // Trigger a click event on the link to start the download
      a.click();
      
      // Release the object URL
      window.URL.revokeObjectURL(url);
      
    }
    if(allowed){
      return (
        <>
        <div className="form-question">

        <button onClick={downloadCSV} className="form-submit">Download CSV</button>
        </div>
        <div style={{ display: "flex", textAlign: "left", overflowX: "auto",margin: "10px auto"}}>
  <table
    style={{
      backgroundColor: '#fff',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
      borderRadius: '8px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      width: '90%', // Ensure the table takes up the full width of its container
      margin: "auto"
    }}
  >
    <thead>
      <tr>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>Time</th>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>Name</th>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>PRN</th>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>Phone No.</th>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>Department</th>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>Email Address</th>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>IEEE ID</th>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>Year</th>
        <th style={{ fontWeight: 'bold',padding: "10px", marginBottom: '20px', color: '#333' }}>Payment</th>
      </tr>
    </thead>
    <tbody>
      {bigData.map((man, index) => (
        <tr key={index}>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{(new Date(man.timestamp.seconds*1000)).toLocaleString()}</td>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{man.fullName}</td>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{man.prn}</td>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{man.wpMobNo}</td>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{man.branch}</td>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{man.email}</td>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{man.ieeeMember ? man.memberId : "none"}</td>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{man.yrr}</td>
          <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}><button onClick={() => { openModal(man.prn) }}>View</button></td>
        </tr>
      ))}
    </tbody>
  </table>
  <Modal
    isOpen={modalIsOpen}
    onRequestClose={closeModal}
    style={customStyles}
    contentLabel="Example Modal"
    ariaHideApp={false}
  >
    <img id='myimg' style={{ height: '400px' }}></img>
  </Modal>
</div>
</>
      );
    }
   else return(
      <h1 style={{margin: "50%"}}>Access Denied</h1>
    )
};

export default Dashboard;

